import { render, staticRenderFns } from "./ListMyLecture.vue?vue&type=template&id=74a81b7a&"
import script from "./ListMyLecture.vue?vue&type=script&lang=js&"
export * from "./ListMyLecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports